import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { EntityType } from "../../../types/ScientificModule";
import { routes } from "../../../routes";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { createEntity } from "../../../services/scientific/entity";
import { CreateEntityFormValidation } from "./CreateEntityValidationForm";
import { Countries, Country } from "../../../utils/codes";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";

export const CreateEntity = () => {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createEntity, mutationKey: "createEntity" });

  const defaultValues: EntityType = {
    id: "",
    description: "",
    country: "MOZ",
    status: true,
  };

  const { control, handleSubmit, formState: { errors } } = useForm<EntityType>({
    resolver: yupResolver(CreateEntityFormValidation),
    defaultValues,
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Entidade criada com sucesso!");
        navigate(routes.entities);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    navigate(routes.entities);
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1">
        <Flex direction="column" gap="4">
          <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: "Descrição" }} required={true}/>
          <SelectComponent
                name="country"
                label="País"
                control={control}
                errors={errors}
                options={Countries?.map((country:Country) => ({
                  value: country.code,
                  label: country.label ?? "",
                }))}
                style={{width:'100%'}} 
                required={true}
              />
          <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
            <Button color="red" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant="surface">
              {mutation.isLoading ? <Spinner loading><EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
};
